(function (upp) {
    'use strict';

    upp.service('eShopService', ['productsDao',
        function (ProductsDao) {
            var URL_API_REST_SERVER = $UPP.URL_UPPLICATION_REST_SERVICE + "eshop",
                DEFAULT_REQUEST_ROWS = 6,
                dao = ProductsDao.create(URL_API_REST_SERVER);

            /**
             * Returns a part of the list of available products in the eshop
             *
             * @method listEshopProducts
             * @param {Object} params {pagination, filter}
             * @return {Promise} Returns a promise that will be fulfilled (Array of X number products, currency object, and postage amount) or rejected(error)
             */
            var listEshopProducts = function (params) {
                var dummy;

                return dao.listProducts({
                    pagination: {
                        maxRows: params && (dummy = params.pagination) && (dummy = dummy.maxRows) ? dummy : DEFAULT_REQUEST_ROWS,
                        currentPage: params && (dummy = params.pagination) && (dummy = dummy.page) ? dummy : 1
                    },
                    filter: params && params.filter,
                    order: params && params.order,
                    search: params && params.search
                });
            };

            /**
             * Returns info about a specific product
             *
             * @method getProduct
             * @param {String} id Identification of the product
             * @return {Promise} Returns a promise that will be fulfilled (Product, currency object and postage amount) or rejected(error)
             */
            var getEshopProduct = function (id) {
                return dao.getProduct(id);
            };

            return{
                listEshopProducts: listEshopProducts,
                getEshopProduct: getEshopProduct
            };
        }]);

    upp.service('catalogFiltersService', ['$location', function ($location) {
        var filters = ['category', 'subcategory', 'order', 'text'];

        /**
         * Set filters.
         * If null delete the key
         * @param {Number} category
         * @param {Number} subcategory
         * @param {Number} order price to save
         * @param {String} text
         */
        var setFilters = function (category, subcategory, order, text) {
            $location.search('category', category);
            $location.search('subcategory', subcategory);
            $location.search('order', order);
            $location.search('text', text);
        };

        /**
         * Retrieve all filters
         * @returns {Object}
         */
        var getFilters = function () {
            var result = {};

            filters.forEach(function(key) {
                result[key] = $location.search()[key];
            });

            return result;
        };

        /**
         * Clear all filters
         */
        var clearFilters = function () {
            filters.forEach(function(key) {
                $location.search(key, null);
            });
        };

        return {
            set: setFilters,
            get: getFilters,
            clear: clearFilters
        };
    }]);

})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/eshop/services/eshop-services.js